import React, { Component } from "react";
import { Link } from 'react-router-dom';
import PageProjectsThumb from './PageProjectsThumb';


export default class PageProjects extends Component {
	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <>
			    	
			    	{block.heading_size != 'small' &&
				    	
			    		<div className="c-page__block c-page__block--space-small c-page__block--load-effect">
					
							<div className="l-content l-content--fixed-width">
		    				
		    					<div className="l-grid">
		    				
		    						<div className="l-grid__col">
		    					
		    							<h4 className="c-paragraph c-paragraph--xxxlarge" dangerouslySetInnerHTML={{__html:block.heading}}></h4>
									
									</div>
									
								</div>
								
							</div>
							
						</div>
						
					}
									
					{block.heading_size == 'small' &&
				    	
			    		<div className="c-page__block c-page__block--no-space c-page__block--load-effect">
					
							<div className="l-content l-content--fixed-width">
		    				
		    					<div className="l-grid">
		    				
		    						<div className="l-grid__col">
		    					
		    							<h4 className="c-heading" dangerouslySetInnerHTML={{__html:block.heading}}></h4>
																		
									</div>
									
								</div>
					
							</div>
							
						</div>
						
					}
					
					{block.show_filters == 'true' &&
										
				    	<div className="c-page__block c-page__block--space-small c-page__block--load-effect">
						
							<div className="l-content l-content--fixed-width">
			    				
			    				<div className="l-grid">
			    				
			    					<div className="l-grid__col">
			    					
			    						<div className="c-filters">
			    						
			    							<div className="c-filters__header">
			    								<p className="c-filters__header__toggle" onClick={this.handleToggle}>Filter</p>
			    								<Link to={block.parent_url} className="c-filters__header__reset">Reset</Link>
			    							</div>
			    						
			    							{block.types &&
				    							<ul className="c-filters__list">
													{block.types.map((cat,i) => 
														{
															if (cat.active == true) {
																return (
																	<li className="c-filters__list__item" key={i}>
																		<Link to={cat.url} className="c-filters__list__link state-active">{cat.name}</Link>
																	</li>
																)
															} else {
																return (
																	<li className="c-filters__list__item" key={i}>
																		<Link to={cat.url} className="c-filters__list__link">{cat.name}</Link>
																	</li>
																)
															}
														}
													)}
												</ul>
											}
											
											{block.locales &&
				    							<ul className="c-filters__list">
													{block.locales.map((cat,i) => 
														{
															if (cat.active == true) {
																return (
																	<li className="c-filters__list__item" key={i}>
																		<Link to={cat.url} className="c-filters__list__link state-active">{cat.name}</Link>
																	</li>
																)
															} else {
																return (
																	<li className="c-filters__list__item" key={i}>
																		<Link to={cat.url} className="c-filters__list__link">{cat.name}</Link>
																	</li>
																)
															}
														}
													)}
												</ul>
											}
			    						
			    						</div>
									
									</div>
									
								</div>
					
							</div>
							
						</div>
					
					}
				
					<div className={'c-page__block c-page__block--space-' + block.space_after + ' c-page__block--load-effect'}>
						
						<div className="l-content l-content--fixed-width">
		    				
		    				<div className="l-grid">
		    				
		    					<div className="l-grid__col">
		    					
		    						<div className="c-property-thumbs c-property-thumbs--wide">
		    							
		    							{block.project.map((project,i) => 
											{
												return (
													<PageProjectsThumb project={project} key={i}></PageProjectsThumb>
												)
											}
										)}
		    						
		    						</div>
		    						
		    						{block.secproject &&
			    						<div className="c-property-thumbs c-property-thumbs--narrow">
		    							
			    							{block.secproject.map((project,i) => 
												{
													return (
														<PageProjectsThumb project={project} key={i}></PageProjectsThumb>
													)
												}
											)}
			    						
			    						</div>
			    						
		    						}
		    						
		    					</div>
		    					
		    				</div>
		    		
						</div>
		    		
		    		</div>
		    				
		    	</>
			    
			)
			
		} else {
			
			return null;
		
		}
	}
}
